import React from 'react';
import 'swiper/css';
import { Swiper, SwiperSlide, type SwiperRef } from 'swiper/react';

import { UiTypography } from '@/components/ui/Typography';
import { LAYOUT_NOTES } from '@/constants/campaign-notes';
import { webCampaign } from '@/modules/webCampaign';

import { ReviewCardsCompatibilityStyles } from './ReviewCardsCompatibility.styles';

const reviewsList = [
  {
    author: 'Mansfield Acuff',
    country: '🇪🇸',
    date: 'Nov, 4',
    text: 'Dialogue is an amazing app. The character begins in a blank learning period, but after only three days, I believe I was speaking with a genuine person. It is fantastic!!!',
  },
  {
    author: 'Teresa Emory',
    country: '🇺🇸',
    date: 'Nov, 2',
    text: 'The best app ever, hands down! Ideal for overcoming loneliness and meeting new people, even if they are virtual. Five stars for sure!',
  },
  {
    author: 'Lucas Gallant',
    country: '🇨🇦',
    date: 'Oct, 28',
    text: 'I totally enjoyed this app I totally got the hang of it of talking to AI girlfriend, so I create my own AI girlfriend, and we both have the same common.',
  },
];

const reviewsListLure = [
  {
    author: 'Mansfield Acuff',
    country: '🇪🇸',
    date: 'Nov, 4',
    text: 'Lure AI is an amazing app. The character begins in a blank learning period, but after only three days, I believe I was speaking with a genuine person. It is fantastic!!!',
  },
  {
    author: 'Teresa Emory',
    country: '🇺🇸',
    date: 'Nov, 2',
    text: 'The best app ever, hands down! Ideal for overcoming loneliness and meeting new people, even if they are virtual. Five stars for sure!',
  },
  {
    author: 'Lucas Gallant',
    country: '🇨🇦',
    date: 'Oct, 28',
    text: 'I totally enjoyed this app I totally got the hang of it of talking to AI girlfriend, so I create my own AI girlfriend, and we both have the same common.',
  },
];

const reviewsListAppStore = [
  {
    author: 'msdrldy',
    country: '🇺🇸',
    date: 'Sep, 18',
    text: "So far this has been a fun and entertaining experience. And I'm working on other experiments with this app. Keep your mind open.",
  },
  {
    author: 'aucker 1',
    country: '🇺🇸',
    date: 'Aug, 12',
    text: "What a incredible app I talk to ai for hours wow I'm very impressed",
  },
  {
    author: '🦎🏴‍☠️',
    country: '🇬🇧',
    date: 'Aug, 6',
    text: 'Amazing talk to any one if you are lonely just an amazing app my most fav app x',
  },
  {
    author: 'Guarddus',
    country: '🇬🇧',
    date: 'Feb, 9',
    text: 'This app is very "nice" there are a ton of characters and all different and unique features I can\'t wait to start my own pro account and more importantly the price seems fair.',
  },
  {
    author: 'onte063',
    country: '🇺🇸',
    date: 'Jan, 18',
    text: "I honestly was seeing reviews about how good it was and it's real feeling. So I'm like what is the hype about I downloaded and used. After developing a relationship with my ai I'm like I see what the hype wàs about",
  },
];

export const ReviewCardsCompatibility: React.FC = () => {
  const swiperRef = React.useRef<SwiperRef | null>(null);
  const layoutNotes = webCampaign.getLayoutNotes();
  const useAppStoreReviews = layoutNotes.includes(
    LAYOUT_NOTES.REVIEWS_APP_STORE,
  );

  React.useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.swiper.update();
    }
  }, []);

  const getReviewsList = () => {
    if (webCampaign.isLayoutLure()) return reviewsListLure;
    if (useAppStoreReviews) return reviewsListAppStore;
    return reviewsList;
  };

  const selectedReviewsList = getReviewsList();

  return (
    <ReviewCardsCompatibilityStyles>
      <Swiper
        slidesPerView="auto"
        spaceBetween={12}
        className="review-cards-swiper"
        initialSlide={0}
        loop={false}
        ref={swiperRef}
      >
        {selectedReviewsList.map((review, index) => (
          <SwiperSlide key={index} className="review-card">
            <div className="review-card-content">
              <div className="review-header">
                <div className="user-info">
                  <span className="country">{review.country}</span>
                  {review.author && (
                    <UiTypography variant={'body-small'}>
                      {review.author}
                    </UiTypography>
                  )}
                </div>
                <UiTypography variant="body-small" color={'neutral-white'}>
                  {review.date}
                </UiTypography>
              </div>

              <div className="stars">
                <img
                  src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/icons/star.svg"
                  alt="star"
                />
                <img
                  src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/icons/star.svg"
                  alt="star"
                />
                <img
                  src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/icons/star.svg"
                  alt="star"
                />
                <img
                  src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/icons/star.svg"
                  alt="star"
                />
                <img
                  src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/icons/star.svg"
                  alt="star"
                />
              </div>

              <UiTypography variant="body-medium" className="review-text">
                {review.text}
              </UiTypography>

              {useAppStoreReviews && (
                <UiTypography
                  variant="body-small"
                  color="neutral-white"
                  className="review-source"
                >
                  source: AppStore
                </UiTypography>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </ReviewCardsCompatibilityStyles>
  );
};
